export function mapPhone(phone: string): string {
    if (!phone) {
        return null;
    }

    return phone.replace(/[- \s]/g, '');
}
